var React = require('react');

function IcnAnchor (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icn_anchor"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icn_anchor","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M1.9,10 C1.9,8.29 3.29,6.9 5,6.9 L9,6.9 L9,5 L5,5 C2.24,5 0,7.24 0,10 C0,12.76 2.24,15 5,15 L9,15 L9,13.1 L5,13.1 C3.29,13.1 1.9,11.71 1.9,10 Z M6,11 L14,11 L14,9 L6,9 L6,11 Z M15,5 L11,5 L11,6.9 L15,6.9 C16.71,6.9 18.1,8.29 18.1,10 C18.1,11.71 16.71,13.1 15,13.1 L11,13.1 L11,15 L15,15 C17.76,15 20,12.76 20,10 C20,7.24 17.76,5 15,5 Z","id":"Shape","fill":"#0089FF","fillRule":"nonzero","transform":"translate(10.000000, 10.000000) rotate(-315.000000) translate(-10.000000, -10.000000) "}))]);
}

IcnAnchor.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = IcnAnchor;

IcnAnchor.default = IcnAnchor;
